import { FORMAT_LOCALE } from '@capdesk/utils'

export const formatPercentage = (value: number, { minimumFractionDigits = 0, maximumFractionDigits = 2 } = {}) => {
  return new Intl.NumberFormat(FORMAT_LOCALE, {
    style: 'percent',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)
}
